import { Button } from '@nf/ui';
import { Modal } from '@/components/widgets/modal';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';
import { ThumbUpIcon, ThumbDownIcon } from '@/components/icons/svg-icons'
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';

import clsx from 'clsx';
import { bookingRulesPopupStyle } from './booking-rules-popup.style';
import { KafkaNote } from '@nf/utils-common/constants';

interface RulesPopupProps {
    isShowRules: boolean;
    setIsShowRules: (isShowRules: boolean) => void;
}

export const BookingRulesPopup = ({ isShowRules, setIsShowRules }:RulesPopupProps) => {
	const t = useTranslations('General');
	const [isShowFeedback, setIsShowFeedback] = useState(true);
	const [feedbackStatus, setFeedbackStatus] = useState('');


	const closeRulesPopup = () => {
		if (feedbackStatus) {
			localStorage.setItem('has-rules-feedback-record', 'true');
			const kafkaData = {
				type: 4,
				action: feedbackStatus === 'like' ? 1  : 2,
				note: KafkaNote.EuroCup
			}
			setKafkaNormal(kafkaData);
		}
		setIsShowRules(false);
	}

	const clickFeedback = (status: string) => {
		setFeedbackStatus(status);
	}

	useEffect(() => {
		// check if feedback record exists       
		if (typeof window !== 'undefined' && window.localStorage) {
			const showFeebblackBlock =!(localStorage.getItem('has-rules-feedback-record'))
			setIsShowFeedback(showFeebblackBlock);
		}
	}, [])
    
	return (
		<Modal
			variant="top"
			isOpen={isShowRules}
			closeModal={closeRulesPopup}
			showHeader={true}
			title={t('lbl_ECPBBRRTitle')}
			className={bookingRulesPopupStyle.rulesModal}
		>
			<section className="rules-modal scrollbar">
				<div className="rules-modal__title">{t('lbl_ECPRRTermsAndRules')}</div>
				<ul>
					<li>{t('lbl_ECPRRBetTerms01')}</li>
					<li>{t('lbl_ECPRRBetTerms02')}</li>
					<li>{t('lbl_ECPRRBetTerms03')}</li> 
					<li>{t('lbl_ECPRRBetTerms04')}</li>
					<li>{t('lbl_ECPRRBetTerms05')}</li>
				</ul>
				<div className="rules-modal__title">{t('lbl_ECPRRSpecialLimits')}</div>
				<ul>
					<li>{t('lbl_ECPRRSpecialLimits01')}</li>
					<li>{t('lbl_ECPRRSpecialLimits02')}</li>
					<li>{t('lbl_ECPRRSpecialLimits03')}</li>
					<li>{t('lbl_ECPRRSpecialLimits04')}</li>
				</ul>
				<div className="rules-modal__title">{t('lbl_ECPRRInvalidatingBet')}</div>
				<ul>
					<li>{t('lbl_ECPRRInvalidatingBet01')}</li>
					<li>{t('lbl_ECPRRInvalidatingBet02')}</li>
					<li>{t('lbl_ECPRRInvalidatingBet03')}</li>
					<li>{t('lbl_ECPRRInvalidatingBet04')}</li>
					<li>{t('lbl_ECPRRInvalidatingBet05')}</li>
					<li>{t('lbl_ECPRRInvalidatingBet06')}</li>
					<li>{t('lbl_ECPRRInvalidatingBet07')}</li>
					<li>{t('lbl_ECPRRInvalidatingBet10')}</li>
					<li>{t('lbl_ECPRRInvalidatingBet08')}</li>
					<li>{t('lbl_ECPRRInvalidatingBet09')}</li>
				</ul>
				<div className="rules-modal__title">{t('lbl_ECPRRRules')}</div>
				<ul>
					<li>{t('lbl_ECPRRBBRules01')}</li>
					<li>{t('lbl_ECPRRBBRules02')}</li>
					<li>{t('lbl_ECPRRBBRules03')}</li>
					<li>{t('lbl_ECPRRBBRules04')}</li>
					<li>{t('lbl_ECPRRBBRules05')}</li>
				</ul>

				{/* Feedback TODO: setKafka*/}
				{isShowFeedback ? (
					<div className={clsx('feedback', bookingRulesPopupStyle.feedback)}>
						<span className="feedback__title">{t('lbl_ECPHelpful')}</span>
						<div className="feedback__btn">
							<Button
								variant="icon"
								className={bookingRulesPopupStyle.feedbackButton}
								data-selected={feedbackStatus==='like'}
								onClick={() => clickFeedback('like')}
							>
								<ThumbUpIcon />
							</Button>
							<Button
								variant="icon"
								className={bookingRulesPopupStyle.feedbackButton}
								data-selected={feedbackStatus==='dislike'}
								onClick={() => clickFeedback('dislike')}
							>
								<ThumbDownIcon />
							</Button>
						</div>
					</div>) : null}
			</section>
		</Modal>
	)
};